import EmptyState from '@/components/linear/empty-state';
import PageToolbar from '@/components/linear/page-toolbar';
import { inboxPath } from '@/lib/linear-paths';
import { Link, usePage } from '@inertiajs/react';

interface NotFoundProps {
  reactLayout?: string;
  homePath?: string;
  currentUser?: { id: string } | null;
  [key: string]: unknown;
}

const DESCRIPTION = 'This page does not exist or you do not have access to it.';

// Staff see this inside the workspace. A visitor or a builder sees a plain page.
const NotFound = () => {
  const { reactLayout, homePath, currentUser } = usePage<NotFoundProps>().props;

  if (reactLayout === 'workspace') {
    return (
      <div className="ln-page">
        <PageToolbar
          title="Page not found"
          tabs={
            <Link href={inboxPath()} className="ln-tab">
              Inbox
            </Link>
          }
          showNew={false}
        />
        <div className="ln-page-scroll">
          <EmptyState title="Page not found" description={DESCRIPTION} />
        </div>
      </div>
    );
  }

  return (
    <>
      <h1 className="authority-display text-3xl leading-tight">Page not found</h1>
      <p className="text-muted-foreground mt-4 text-sm">{DESCRIPTION}</p>
      {currentUser && homePath && (
        <p className="mt-6 text-sm">
          <Link href={homePath} className="underline underline-offset-4">
            Go to your apps
          </Link>
        </p>
      )}
    </>
  );
};

export default NotFound;
